/**
 * Get current date in English format: "Month Day, Year"
 * Example: "December 7, 2024"
 */
export const getCurrentDate = () => {
  const date = new Date();
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return date.toLocaleDateString('en-US', options);
};

/**
 * Get current year
 * Example: "2024"
 */
export const getCurrentYear = () => {
  return new Date().getFullYear();
};

/**
 * Get copyright year range
 * Example: "2018-2024"
 */
export const getCopyrightYears = (startYear = 2018) => {
  const currentYear = getCurrentYear();
  return startYear === currentYear ? `${currentYear}` : `${startYear}-${currentYear}`;
};

/**
 * Get current month name
 * Example: "December"
 */
export const getCurrentMonth = () => {
  const date = new Date();
  return date.toLocaleDateString('en-US', { month: 'long' });
};

/**
 * Get current day
 * Example: "7"
 */
export const getCurrentDay = () => {
  return new Date().getDate();
};
